let varientMapper = {
  "Cobalt Blue": ["https://cdn.shopify.com/s/files/1/0696/1011/1257/files/cobalt-blue_50x50.png", true],
  "Black": ["#000", false],
  "Ochre": ["#cc7722",false],
  "Blush": ["#fe828c",false],
    "Cream": ["#FFFDD0",false],
  "Mint": ["#3EB489",false],
  "Olive Green": ["#BAB86C",false],
  "Sand": ["#C2B280",false],
  "Turquise": ["#30D5C8",false],
  "Marigold": ["#EAA221",false]
}

const changeTemplate = (div) => {
  let oldDiv = document.getElementById(div);
  let newDiv = document.getElementById(div+"-new").text;
  oldDiv.text = newDiv;
}

window.onWizzyScriptLoaded = function () {

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-sort");
  changeTemplate("wizzy-autocomplete-topproducts");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
         data.common.lazyDOMConfig.searchInputIdentifiers.push({
        "dom": "input.search-bar__input",
        "type": "text"
    });

    data.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");  
    return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      let element = document.querySelector(".search-bar__close-button.hidden-tablet-and-up");
      if(element){
        element.click();
      }
    return data;
    }
  );

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
    // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
    let x = document.querySelector(".wizzy-body-end-wrapper");
    if(x && typeof data.isForDefault !== 'undefined' && data.isForDefault === true) {
      x.classList.add("wizzy-view-more-hide");
    }else if(x && x.classList.contains("wizzy-view-more-hide")) {
      x.classList.remove("wizzy-view-more-hide");
    }
    return data;
  })

    function findHaxCode(key){
    console.log();
    if(varientMapper[key] && varientMapper[key][0]){
      return [varientMapper[key][0],varientMapper[key][1]]
    }
    return [key,false]
  }


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER, function (payload) {
    // console.log(payload, "<===BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER");
    let totalLen = payload.suggestions.length;
    if(totalLen > 0) {
      let temp = payload.suggestions.filter(function(item) {
        return item.group === 'others';
      });

      payload.suggestions = payload.suggestions.filter(function(item) {
        return item.group !== 'others';
      });

      let othersLen = temp.length;
      for(let i = othersLen - 1; i >= 0; i--) {
        payload.suggestions.unshift(temp[i]);
      }
      
    }
    return payload;
  });
  
  
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function (payload) {
    // console.log(payload);
    if(payload.api === 'search' || payload.api === "filter"){
      var facets = payload.response.payload.facets;
  
      facets.forEach((facet)=>{
   
        if(facet.key === "colors"){
           const facetItem = facet.data;
   
          facetItem.forEach((item)=>{
            let [haxcode,isURLSwatch]=findHaxCode(item.key);
        
            item.isSwatch = true;
            item.isURLSwatch = isURLSwatch;
            item.isVisualSwatch =true;
            item.swatchValue = haxcode;
            item.data = {value: item.key, swatch: {type: 'visual', value: haxcode}}
              
          })
        }
  
      })
      
    }
       
    return payload;
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function(data){
      // console.log(data);
      data.forEach(product => {
        product.separator = product.url.includes('?') ? '&' : '?';
        if(product.sellingPrice) {
          let sellingPriceLength = product.sellingPrice.length;
          if(sellingPriceLength >= 3 && product.sellingPrice[sellingPriceLength - 3] === '.') {
            product.sellingPrice = product.sellingPrice + "0";
          }else {
            product.sellingPrice = product.sellingPrice + ".000";
          }
        }

        if(product.price) {
          let priceLength = product.price.length;
          if(priceLength >= 3 && product.price[priceLength - 3] === '.') {
            product.price = product.price + "0";
          }else {
            product.price = product.price + ".000";
          }
        }

        product.attributes.forEach((attr) => {
          if (attr.id === "product_tags") {
            if(attr.values[0].value[0].includes("New Arrival")) {
              product.newArrival = true;
            }
          }
        })
        
      });
      return data;
    }
  )
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const wizzyLazyAssetUtils = {
  isWizzyLazyLoaded: false,
  isCollectionEnabled: true,
  wizzyStore: JSON.parse(window.localStorage.getItem('wizzy_store')) ?? false,
  collectionId: document.querySelector("[data-collection-id]")?.getAttribute("data-collection-id") ?? false,
  productId: document.querySelector("[data-product-id]")?.getAttribute("data-product-id") ?? false,
  pageHandle: document.querySelector("[data-page-handle]")?.getAttribute("data-page-handle") ?? false,
  currentEle: null,
  enableWizzyAssets(targetEle = null) {
    // console.log("Wizzy enable lazy assets again")
    if (!this.isWizzyLazyLoaded) {
      this.isWizzyLazyLoaded = true;
      
      window.wizzyLazyAssets.load();
    }

  },
  isValidTargetEleToEnable(targetEle) {
    return targetEle.getAttribute("name") == "q" &&
      targetEle.getAttribute("type") == "search";
  },
  clickCondition(targetEle) {
    var self = wizzyLazyAssetUtils;
    return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
  },
  keyDownCondition(targetEle) {
    var self = wizzyLazyAssetUtils;
    return wizzyLazyAssetUtils.isValidTargetEleToEnable(targetEle);
  },
  handleInitClick(e) {
    var self = wizzyLazyAssetUtils;
    let targetEle = e.target;
    if (self.clickCondition(targetEle)
      &&
      !window.isWizzyLazyLoaded
    ) {
      self.currentEle = targetEle;
      self.enableWizzyAssets(targetEle);

      document.removeEventListener("click", self.handleInitClick);
    }
  },
  handleInitKeyDown(e) {
    var self = wizzyLazyAssetUtils;
    let targetEle = e.target;
    if (self.keyDownCondition(targetEle)
      &&
      !window.isWizzyLazyLoaded
    ) {
      self.currentEle = targetEle;
      self.enableWizzyAssets(targetEle);
      document.removeEventListener("keydown", self.handleInitKeyDown);
    }

  },
  attachEvents() {
    var self = wizzyLazyAssetUtils;
    document.addEventListener("click", self.handleInitClick);
    document.addEventListener("keydown", self.handleInitKeyDown);

    window.addEventListener("onWizzyScriptLoaded", () => {
      window.wizzySearchInit();
    });

    window.addEventListener("onWizzyInit", () => {
      if (self.currentEle) {
        setTimeout(() => {
          self.currentEle.click();
        }, 10);
      }
      document.removeEventListener("click", self.handleInitClick);
    });
  },
  isOnValidaProductPage() {
    let self = wizzyLazyAssetUtils;
    return self.wizzyStore
      && typeof self.wizzyStore == 'object'
      && self.wizzyStore.hasOwnProperty('CLICKED_PRODUCTS')
      && typeof self.wizzyStore['CLICKED_PRODUCTS'] == 'object'
      && self.wizzyStore['CLICKED_PRODUCTS'].hasOwnProperty(self.productId)
      ;
  },
  isOnCollectionPage() {
    let self = wizzyLazyAssetUtils;
    return self.isCollectionEnabled && self.collectionId != undefined && self.collectionId != "" && self.collectionId != null;
  },
  isNeedToAutoInitWizzy() {
    var self = wizzyLazyAssetUtils;
    // console.log(self.pageHandle == "/pages/search" || self.isOnValidaProductPage() || self.isOnCollectionPage(), "<=== wizzy return");
    return self.pageHandle == "/pages/search" || self.isOnValidaProductPage() || self.isOnCollectionPage();
  },
  init() {
    var self = wizzyLazyAssetUtils;
    this.attachEvents();
    // console.log(!window.wizzyConfigUpdated);
    if (!window.wizzyConfigUpdated) {
      let wizzyCategoryPageInterval = setInterval(() => {
        if (window.wizzyConfigUpdated) {
          clearInterval(wizzyCategoryPageInterval);
          if (self.isNeedToAutoInitWizzy())
            self.enableWizzyAssets();

        }
      }, 10);
    } else {
      // console.log(self.isNeedToAutoInitWizzy(),"wizzy isNeedToAutoInitWizzy");
      if (self.isNeedToAutoInitWizzy())
        self.enableWizzyAssets();

    }
  },
};

window.onload = (e) => wizzyLazyAssetUtils.init();

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////